module.exports = "https://static.energy5.com/_next/static/images/replacementsImage-2f4f0bce36236f23538e6946f6ceb616.jpg";